import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { apiGet, apiPost } from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: returning from Google OAuth — AuthCallback exchanges session_id first
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    (async () => {
      try {
        setUser(await apiGet('/auth/me'));
      } catch {
        try {
          await apiPost('/auth/refresh');
          setUser(await apiGet('/auth/me'));
        } catch {
          setUser(null);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const u = await apiPost('/auth/login', { email, password });
    setUser(u);
    return u;
  };

  const register = async (name, email, password) => {
    const u = await apiPost('/auth/register', { name, email, password });
    setUser(u);
    return u;
  };

  const logout = async () => {
    try {
      await apiPost('/auth/logout');
    } catch {}
    setUser(null);
  };

  const value = useMemo(() => ({ user, loading, setUser, login, register, logout }), [user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
